import { useContext } from "react";
import debug from "debug";
import { getDictionary, getTranslationValue, translate } from "@jti/fe-common";
import { TranslationsContext } from "./contexts";
const log = debug("desjti:configProvider:useTranslations");
export const useTranslations = () => {
    try {
        const dictionary = useContext(TranslationsContext);
        if (!dictionary) {
            throw Error("useTranslations hook used outside of TranslationsProvider. no dictionary provided.");
        }
        return { __: getTranslationValue(dictionary), dictionary };
    }
    catch (error) {
        if (error instanceof Error) {
            log(error.message);
        }
        return { __: translate, dictionary: getDictionary() };
    }
};
//# sourceMappingURL=useTranslations.js.map